import React, { useEffect, useMemo } from 'react';
import MainContainerComponent from '../../components/MainContainerComponent';
import { useLocation, useParams } from 'react-router-dom';
import { APP_URL } from '../../constants';
import { getParam } from '../../functions';

const SocialAuthCallbackPage = () => {
  const { provider } = useParams();
  const { search } = useLocation();
  const url = useMemo(() => {
    const code = getParam('code', search);
    if (!provider || !code) {
      return null
    }
    return `${APP_URL}auth/${provider}/${code}`

  }, [provider, search])

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }

  }, [url])
  return (
    <MainContainerComponent
      title="Już prawie skończone"
      subtitle="Kliknij przycisk poniżej, aby przejść do pełnej funkcjonalności i rozpocząć niezapomnianą podróż z naszą aplikacją. Czekają na Ciebie unikalne funkcje, emocjonujące treści i wiele więcej. Przejdź do aplikacji i zacznij korzystać z niej już teraz! 🌟"
    >
      {url
        ? <a href={url} className="btn">
          PRZEJDŹ DO APLIKACJI
        </a>
        : <></>
      }
    </MainContainerComponent>
  );
};

export default React.memo(SocialAuthCallbackPage);
